import { Injectable } from '@angular/core';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { iCondicionPago } from '../models/iCondicionPago';

@Injectable({
    providedIn: 'root'
})

export class CondicionPagoService {

    constructor(private apiService: ApiService) { }

    insertar(data: iCondicionPago): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_CRUD_url);
        return this.apiService.executePostJson(data).pipe();
    }

    modificar(data: iCondicionPago): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_CRUD_url);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar(codpag: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_CRUD_url);
        return this.apiService.executeDeleteJson(`/${codpag}`)
    }

    eliminarclase(codpag: any, codigo: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_CRUD_url);
        return this.apiService.executeDeleteJson(`/clase/${codpag}/codigo/${codigo}`)
    }

    eliminardetalle(codpag: any, item: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_CRUD_url);
        return this.apiService.executeDeleteJson(`/detalle/${codpag}/item/${item}`)
    }

    obtener(codpag: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_CRUD_url);
        return this.apiService.execGetQueryJson(`/${codpag}`)
    }

    busar(codcli: string, activo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_buscar);
        return this.apiService.execGetQueryJson(`codcli=${codcli}` + ((activo != null) ? ("&activo=" + activo) : ""));
    }

    busarclases(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.condicion_pago_CRUD_url);
        return this.apiService.execGetQueryJson(`/clases`)
    }
}